module.exports = __webpack_public_path__ + "img/like.6f947438.gif";